// @flow

import ko from 'rgs-knockout';
import { JSable } from 'jsable';
import { observableISODate } from 'observable-iso-date';

export class AccidentMailingListCertificate
	extends JSable {

	AccidentCertificateID = ko.observable().extend({ toFromJS: true });
	AccidentCertificateNumber = ko.observable().extend({ toFromJS: true });
	InsurancePeriodStart = observableISODate().extend({ toFromJS: true });
	InsurancePeriodEnd = observableISODate().extend({ toFromJS: true });
	InsurerName = ko.observable().extend({ toFromJS: true });
	InsurerEmail = ko.observable().extend({ toFromJS: true });
	Status = ko.observable().extend({ toFromJS: true });
	StatusDescription = ko.observable().extend({ toFromJS: true });
	checked = ko.observable().extend({ toFromJS: true });
}
